import { CartItemDTO } from "./Cart";

export interface Favourite {
    id: string | null;
    productId: string| null;
    userId: string| null;
    price?: number| null;
    name?: string| null;
    image? : string | null;
    sku? : string | null;
}

export function toCartItemDTO(fav : Favourite): CartItemDTO {
    return {
        id: null,
        productId : fav.productId,
        userId: fav.userId,
        price: fav.price,
        name : fav.name,
        image : fav.image,
        sku : fav.sku,
        quantity : 0
    };
}

export function createFavourite(): Favourite {
    return {
        id: null,
        productId : null,
        userId: null,
        price: 0,
        name : '',
        image : '',
        sku : '',
    };
}